import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { concat, finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { CandidateDocuments, DocumentInstructions, DocumentType, EmployeeDoc, EmployeeDocDelete, EmployeeProfile, EmployeeProfileApi, LookupField, ImmigrationApi, EmployeeDocCombined } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { LoaderService } from '../../core/loader.service';
import { LookupTypeKeys } from '../lookup-type-keys';
import { ActivatedRoute, Router } from '@angular/router';
import saveAs from 'file-saver';

@Component({
  selector: 'eos-employee-file-upload',
  templateUrl: './employee-file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class EmployeeFileUploadComponent implements OnInit, OnChanges {

  @Input() lookupType: number = 48;
  @Input() employeeProfile: EmployeeProfile;
  @Input() isEdit = false;
  @Input() isAdditionalUpload: boolean = false;
  @Output() activeTabIdxEvent: EventEmitter<any> = new EventEmitter<any>();

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  fileDetails: any;
  allFiles: EmployeeDocCombined[] = [];
  gridFiles: EmployeeDocCombined[] = [];
  selectedDocument: File;
  disableUpload = false;
  editMode = false;
  showUpload = true;
  docName: string;
  docInstruction: string;
  docType = "Download all";
  showSpinner = false;
  ableToSync = false;
  documentList: DocumentType[];
  documentInstructions: DocumentInstructions[] = [];
  distinctDocTypes: DocumentType[];
  docsForDocTypes: DocumentType[];
  immUserProfileView: boolean;
  uploadedCount: number = 0;
  pendingCount: number = 0;
  pendingAllCount: number = 0;
  totalCount: number = 0;
  selectedTab: number = 1;
  allDoc: boolean = false;
  uploadedDoc: boolean = false;
  pendingDoc: boolean = false;
  isMandatoryChecked: boolean = false;
  employeeRPDocuments : number[] = [];



  @Input() readonly = false;
  @Input() candidateForm;
  @Input() isSearch = false;
  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;
  @ViewChild('f') form: NgForm;

  @Output() GetDocumentEvent = new EventEmitter<EmployeeDocCombined[]>();
  @Output() validDocuments = new EventEmitter<LookupField[]>();
  @Output() update = new EventEmitter<boolean>();


  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;


  constructor(
    private employeeApi: EmployeeProfileApi,
    private common: CommonService,
    private dialog: DialogService,
    private openfilepreview: OpenFilePreviewService,
    private toast: ToastService,
    private authService: AuthService,
    private fileUploadService: DocumentUploadService,
    private loader: LoaderService,
    private activeRoute: ActivatedRoute) {
    this.fileDetails = new EmployeeDocCombined();
    this.fileDetails.documentTypeId = null;
    this.fileDetails.documentNameId = null;
    this.activeRoute.params.subscribe(routeParams => {
      this.immUserProfileView = routeParams.immUserProfileView ? true : false;
    });
  }


  ngOnInit() {
    this.getEmployeeRPDocuments();
  }


  ngOnChanges() {
    if (this.employeeProfile && this.employeeProfile.id > 0) {
      this.getEmployeeProfileDocuments();
    }
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  replaceGPNwithCode(docName: string) {
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }



  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }
    return false;
  }

  mandatoryCheck() {
    this.isMandatoryChecked = !this.isMandatoryChecked;
    this.getfileGrid(this.selectedTab);
  }

  browseFile(fileDetails) {


    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.documentTypeId = fileDetails.documentTypeId;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.employeeProfileEditRequestId = fileDetails.employeeProfileEditRequestId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.description = fileDetails.description ? fileDetails.description : '';
    this.fileDetails.combainedId = fileDetails.documentNameId + '~' + fileDetails.documentName;

    this.fileDetails.employeeProfileEditRequestId = this.employeeProfile.id;
    this.fileDetails.employeeId = this.employeeProfile.employeeId != null ? this.employeeProfile.employeeId : 0;
    this.fileDetails.employeeProfileId = this.employeeProfile.id;


    this.fileDetails.additionalReqId = fileDetails.additionalReqId;
    this.fileDetails.dependentId = fileDetails.dependentId;


    this.fileEle.nativeElement.click();

  }

  closeEdit(fileDetails: EmployeeDocCombined) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = false;
    this.fileDetails.isEditMode = false;
  }


  edit(fileDetails: EmployeeDocCombined, i) {

    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = true;

    this.fileDetails.isEditMode = true;
    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.documentTypeId = fileDetails.documentTypeId;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.employeeProfileEditRequestId = fileDetails.employeeProfileEditRequestId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.description = fileDetails.description;
    this.fileDetails.combainedId = fileDetails.documentNameId + '~' + fileDetails.documentName;
  }

  delete(fileDetails) {
    const docDeletReq = new EmployeeDocDelete();
    docDeletReq.employeeDocCombined = fileDetails;
    docDeletReq.isEdit = this.isEdit;
    docDeletReq.isSearch = this.isAdditionalUpload ? true : this.isSearch;
    docDeletReq.profileId = this.employeeProfile.id;
    docDeletReq.employeeProfile = this.employeeProfile;

    this.dialog.showConfirmationBox('Confirm delete',
      'Are you sure you want to delete this file?',
      () => {
        this.employeeApi.deleteFile(docDeletReq).subscribe((resp) => {
          if (resp) {
            this.toast.success("Document deleted!");
          } else {
            this.toast.error("Document deletion failed!");
          }

          this.update.emit();

          this.getEmployeeProfileDocuments();
        });
      });
  }


  preview(details: EmployeeDoc) {

    this.openfilepreview.getFilePreviewToken(details).then(token => {
      this.tryOpenInNativeApp(token, details);
    }).catch(err => {
    });
  }

  tryOpenInNativeApp(token: string, details: EmployeeDoc) {
    const extension: string = details.fileName.split('.').pop();
    this.docName = `${details.documentName}.${extension}`;

    this.openfilepreview.previewFile(token, details.fileGuiId, this.docName).catch(r => {
      if (extension.toLowerCase() === 'pdf') {
        this.previewPDFFile(token, details);
      } else if (['png', 'jpg', 'jpeg'].indexOf(extension.toLowerCase()) > -1) {
        this.previewImageFile(token, details);
      }
    });
  }

  previewPDFFile(token: string, details: EmployeeDoc) {
    this.dialog.showPDFPreviewiew(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  previewImageFile(token: string, details: EmployeeDoc) {
    this.dialog.showImagePreview(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  downloadDocument(details: EmployeeDocCombined) {
    const filename = '';
    this.fileUploadService.downloadEmployeeFile(details, filename).subscribe(resp => {
      const extension = this.common.getFileExtension(details.fileName);
      saveAs(resp, `${this.getDocName(details)}${extension}`);
    },
      error => {
        Logger.error(error);
      });
  }


  uploadDoc() {

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between
         ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }

    if (!this.fileDetails.isEditMode) {
      this.fileDetails.id = -1;
      this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    } else {
      this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    }
    this.uploadService();
  }

  get uploadedFiles(): Array<EmployeeDocCombined> {
    if (!this.isAdditionalUpload) {

      return this.allFiles;

    }
    else {
      return this.allFiles.filter(x => x.additionalReqId != null && x.additionalReqId != 0);
    }

  }

  uploadService() {
    this.loader.show();
    this.disableUpload = true;
    if (!this.isSearch) {
      const pathWithProp =
        ["passportExpiryDate", "dateOfBirth", "labourCardExpiryDate",
          "employeeVisaExpiryDate",
          "missionVisaExpiryDate",
          "workPermitExpiryDate",
          "iqamaExpiryDate",
          "dateOfExit",
          "cprExpiryDate",
          "rpExpiryDate",
          "civilIdExpiryDate",
          "pensionRegistrationDate",
          "lastWorkingDay",
        ];
      this.common.updateDateProperty(this.employeeProfile, pathWithProp);
      this.fileUploadService.postEmployeeFile(this.fileDetails, this.employeeProfile, this.isAdditionalUpload, this.selectedDocument).pipe(finalize(() => {
        this.disableUpload = false;
        this.loader.clear();
        }))
        .subscribe(resp => {
          this.uploadReponse(resp);
          this.rpDocValidate(this.fileDetails.documentNameId)
        }, error => {
          this.toast.error("Something went wrong!");
        });
    } else {
      this.fileUploadService.postMainEmployeeFile(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
        this.disableUpload = false;
        this.loader.clear();
      }))
        .subscribe(resp => {
          this.uploadReponse(resp);
          this.rpDocValidate(this.fileDetails.documentNameId)
        }, error => {
          this.toast.error("Something went wrong!");
        });
    }
    this.GetDocumentEvent.emit(this.allFiles);
  }

  rpDocValidate(docId) {
    if (this.employeeRPDocuments.includes(docId)) {
      this.showTab(0);
      let message = "As you have completed the document updates, please verify that the expiry dates have been correctly amended";
      this.dialog.showPopUpMessage(message, null, "");
    }
    return;
  }
  
  showTab(tab: number) {
      this.activeTabIdxEvent.emit(tab);
  }
  uploadReponse(resp) {
    if (this.selectedDocument) {
      this.toast.success("File uploaded successfully!");
    } else {
      this.toast.success("Document details updated successfully!");
    }


    this.update.emit();

    this.getEmployeeProfileDocuments();
  }

  getEmployeeProfileDocuments() {
    if (!this.isAdditionalUpload) {
      this.allFiles = [];
      this.employeeApi.getEmployeeProfileDocuments(this.employeeProfile.id, this.isEdit).subscribe(resp => {

        this.allFiles = resp;
        this.uploadedCount = this.allFiles.filter(x => x.isUploaded).length;
        this.pendingAllCount = this.allFiles.length - (this.allFiles.filter(x => x.isUploaded).length);
        this.pendingCount = (this.allFiles.filter(x => x.mandatoryType == 1).length) - (this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded).length);
        this.totalCount = this.allFiles.length;
        this.gridFiles = this.allFiles;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
      });
    }
    else {
      this.employeeApi.getEligibleAdditionalDocuments(this.employeeProfile.id).subscribe(resp => {
        this.documentList = resp;//.sort((x, y) => (x.isMandatory === y.isMandatory) ? 0 : x.isMandatory ? -1 : 1);
        this.pendingCount = this.documentList.length;
        this.pendingAllCount = this.documentList.length;
        this.allFiles = resp;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
      });
    }
  }


  getfileGrid(type: number) {

    if (!this.isAdditionalUpload) {
      this.selectedTab = 1;
      this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1):this.allFiles;

      this.allDoc = true;
      this.uploadedDoc = false;
      this.pendingDoc = false;

      if (type == 2) {
        this.selectedTab = 2;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded):this.allFiles.filter(x => x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = true;
        this.pendingDoc = false;
      } else if (type == 3) {
        this.selectedTab = 3;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1 && !x.isUploaded):this.allFiles.filter(x => !x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = false;
        this.pendingDoc = true;

      }
    }
    else {
      this.gridFiles = this.allFiles.filter(x => x.additionalReqId != null && x.additionalReqId != 0);
    }

  }


  fileSelected(files: FileList) {

    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;

    this.uploadDoc();
  }

  downloadAll() {

    if (this.showSpinner) {
      return;
    }
    let typeId = -1;
    if ((this.uploadedFiles.length <= 0
      && this.lookupType === LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES)
      || isNullOrUndefined(this.employeeProfile)
      || (this.employeeProfile && this.employeeProfile.id <= 0)) {
      this.toast.warning("No files to download!");
      return;
    }
    if (this.lookupType === LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES) {
      typeId = LookupTypeKeys.IMMIGRATION_DOCUMENT_TYPES;
    } else {
      typeId = this.lookupType;
    }
    // else if (this.lookupType === LookupTypeKeys.PREBOARDING_DOCUMENT_TYPES) {
    //   typeId = LookupTypeKeys.PREBOARDING_DOCUMENT_TYPES;
    // }
    this.showSpinner = true;

    this.fileUploadService.downloadAllEmployeeDocs(this.employeeProfile.id, this.isEdit).pipe(finalize(() => {
      this.showSpinner = false;
    })).subscribe(resp => {

      const countryCode = this.employeeProfile.officeLocationCountry.parentCode ? `${this.employeeProfile.officeLocationCountry.parentCode}` : '';
      const GUI = this.employeeProfile.gui ? `${this.employeeProfile.gui}` : '';
      const preFix = `${countryCode + GUI}_`;
      const fname = nullSafe(() => this.employeeProfile.firstName, 'firstName');
      const lname = nullSafe(() => this.employeeProfile.lastName, 'lastName');
      const filename = `${preFix}${fname}_${lname}`;
      // const gpn = this.candidateForm.value.filter(item => item.gpn !== undefined).map(item => item.gpn).join();

      // const filenames: string[] = [gpn, this.candidateForm.value[0].firstName, this.candidateForm.value[0].lastName];
      // const filename = filenames.filter(name => name !== '' && name !== null && name !== undefined).join('_');

      saveAs(resp, `${filename}.zip`);
    }, err => {
      Logger.error(err);
    });
  }

  setMandatory(id) {
    return false;
  }

  getDocNameForGrid(doc: EmployeeDocCombined) {


    let docName = doc.documentName;
    if (doc.dependentId !== null && doc.dependentId !== 0) {
      if (docName.slice(docName.lastIndexOf('_') + 1) == 'depId') {
        docName = docName.slice(0, docName.lastIndexOf('_') + 1) + doc.dependentName;
      }
    }
    return docName.replace("GPN_", '');
  }

  getDocName(details: EmployeeDocCombined) {
    let parentCode = this.employeeProfile.officeLocationCountry.parentCode;
    let gui = this.employeeProfile.gui;
    let docPrefix = (parentCode !== null && gui !== null) ? parentCode + gui : null;

    if (!docPrefix) {
      return details.documentName.replace("GPN_", '');
    }
    let docN = details.documentName && details.documentName.indexOf("GPN_") > -1 ?
      details.documentName.replace("GPN", `${docPrefix}`) : `${docPrefix}_${details.documentName}`

    if (details.dependentId !== null && details.dependentId !== 0) {
      if (docN.slice(docN.lastIndexOf('_') + 1) == 'depId') {
        docN = docN.slice(0, docN.lastIndexOf('_') + 1) + details.dependentName;
      }
    }

    return docN;
  }

  AdditionalDocReq() {
    this.dialog.EmpAdditionalDocReq(this.employeeProfile,
      (reqList) => {
        this.dialog.showConfirmationBox(
          "Confirm send mail"
          , `This will send a mail to employee to request additional documents from TMT portal. Do you really want to continue?`,
          () => {
            this.loader.show();
            let empId = this.employeeProfile.employeeId == null ? 0 : this.employeeProfile.employeeId;
            this.employeeApi.sendRequestForEmpAdditionalDocs(this.employeeProfile.id, empId, reqList).pipe((finalize(() => {
              this.loader.clear();
            }))).subscribe(resp => {
              this.toast.success("Request sent successfully");
            }, err => {
              this.toast.error("An error ocurred");
            });
          });
      });
  }

  isEditable(item) {

    if (this.isAdditionalUpload) {
      return this.documentList.filter(x => x.additionalReqId == item.additionalReqId).length > 0;
    }
    return true;
  }
  getEmployeeRPDocuments(){
    this.employeeApi.getEmployeeRPDocuments()
    .subscribe(
    (documents: number[]) => {
    this.employeeRPDocuments = documents;
    });
    return;
    }
  }
